import { resolveProtectedPagesJsonFilename } from '@wix/ambassador-document-management-public-editor-info-v1-published-site-details/http'
import type { ResolveProtectedPagesJsonFilenameRequest } from '@wix/ambassador-document-management-public-editor-info-v1-published-site-details/types'
import { createHttpClient } from '@wix/http-client'
import type { PagesMap } from '../types'
// @ts-ignore
import httpAdapter from 'axios/lib/adapters/http'

interface IVerifyPasswordResponse {
	success: boolean
	errorCode: number
	pagesMap: PagesMap
}

export function createProtectedPageAPI(signedInstance: string) {
	const httpClient = createHttpClient({
		baseURL: '/_api/wix-public-html-info-webapp/resolve-protected-pages',
		isSSR: false,
		adapter(config: any) {
			config.url = config.url.replace('/v1/resolve-protected-pages', '')
			return httpAdapter(config)
		},
	})
	const errorTypeToErrorCodeMap: { [key: string]: number } = {
		PAGE_ACCESS_DENIED: -17005,
	} as const
	const VERIFICATION_FAILED_CODE = -19970

	async function doVerify(payload: ResolveProtectedPagesJsonFilenameRequest): Promise<IVerifyPasswordResponse> {
		try {
			const response = await httpClient.request(resolveProtectedPagesJsonFilename(payload), { signedInstance })
			return {
				success: true,
				errorCode: 0,
				pagesMap: response.data.pagesJsonFilename!.reduce((acc, it) => {
					acc[it.pageId!] = it.jsonFilename!
					return acc
				}, {} as PagesMap),
			}
		} catch (ex) {
			const errorType = ex.response?.data?.details?.applicationError?.code
			return {
				success: false,
				errorCode: errorTypeToErrorCodeMap[errorType] ?? VERIFICATION_FAILED_CODE,
				pagesMap: {},
			}
		}
	}

	return {
		verifyPagePassword(pageId: string, password: string) {
			return doVerify({ pageId, password })
		},
		verifySitePassword(password: string) {
			return doVerify({ password })
		},
	}
}
